import { Routes,Route } from 'react-router-dom';
import './App.css';
import Login from './pages/auth/Login';
import Root from './Root';
import PrivateRoute from './components/PrivateRoute';
import ForgotPassword from './pages/auth/ForgotPassword';
function App() {
  return (
      <Routes>
        <Route exact path='/*' element={
         <PrivateRoute>
           <Root/>
         </PrivateRoute>
        }/>
        <Route  path='/login' element={<Login/>}/>
        <Route  path='/forgotpassword' element={<ForgotPassword/>}/>
      </Routes>
  );
}

export default App;
